import { Component, OnInit, OnDestroy, Input,  EventEmitter,  ElementRef, ViewChild} from '@angular/core';
import {IntranetoldService} from './../../../api/intranetold.service'
import {variableGlobal} from './../../../global.enum';
import { NgxIndexedDBService,  } from 'ngx-indexed-db';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, } from "@angular/material/dialog";
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TransbankService, TransbankTerminal } from './../../../api/transbank.service';

import * as _ from 'lodash';
import Swal from 'sweetalert2'


@Component({
  selector: 'app-userEditAdd',
  templateUrl: './addEdit.html',
  styleUrls: ['./user.component.css'],
})

export class UserAddEditComponent implements OnInit {
  @Input() anyDataForm: any;

  constructor(
    public activeModal: NgbActiveModal,
    private _api:IntranetoldService,
    private _tbk: TransbankService
    ) 
    {

    }
  passnew:any;
  data:any = {};
  varglo:any;
  imageError: string;
  isImageSaved: boolean;
  titulo:string = "";
  txtButton:string = "Actualizar";
  ItmsGrpNam:any;
  bodegas: any[] = [];
  terminalesTransbank: TransbankTerminal[] = [];

  ngOnInit(): void {
    this.data.PASSWORDNEW = "";
    this.varglo = variableGlobal;
      
      this.isImageSaved = true;


      this.obtieneListas();

      // Ensure placeholder selection works for BODEGA_DEFAULT when creating new user
      if (this.data.BODEGA_DEFAULT === undefined) {
        this.data.BODEGA_DEFAULT = null;
      }
      // Multi-bodega defaults
      if (this.data.MULTI_BODEGA === undefined) this.data.MULTI_BODEGA = false;
      if (this.data.BODEGAS_TODAS === undefined) this.data.BODEGAS_TODAS = false;
      if (!Array.isArray(this.data.BODEGAS_PERMITIDAS)) this.data.BODEGAS_PERMITIDAS = [];

      // Terminal Transbank default
      if (this.data.TERMINAL_TRANSBANK_DEFAULT === undefined || this.data.TERMINAL_TRANSBANK_DEFAULT === null) {
        this.data.TERMINAL_TRANSBANK_DEFAULT = '';
      }

      if (this.titulo.toUpperCase().includes("NUEVO")) {
        this.txtButton = "Agregar";
      }
  }

  vendedores:any;
  perfiles:any;
  async obtieneListas()
  {

    var objeto:any = {
        "nombre":"OSLP",
        "top":"",
        "where": ""
    };
    //var oslp = await this._api.GetFileQuery(objeto);


  var query = "SELECT [SlpCode], [SlpName] FROM [OSLP]";


    var oslp2:any = await this._api.GetNotFileQuery(query);
    this.vendedores = oslp2.objeto;


    var perfil:any = await this._api.getPerfilAll();
    this.perfiles = perfil.objeto;


    // Bodegas (OWHS) para BODEGA_DEFAULT
  query = "SELECT [WhsCode], [WhsName] FROM [OWHS] WHERE [Inactive] = 'N' ORDER BY [WhsName] ASC";
    try {
      const owhs:any = await this._api.GetNotFileQuery(query);
      this.bodegas = owhs?.objeto || [];
    } catch { this.bodegas = []; }

    // Terminales Transbank
    try {
      const resTbk: any = await this._tbk.getTerminales();
      this.terminalesTransbank = (resTbk?.estado && Array.isArray(resTbk?.objeto)) ? resTbk.objeto : [];
    } catch { this.terminalesTransbank = []; }

    // Categorías OITB
    query = "SELECT [ItmsGrpNam],[ItmsGrpCod] FROM [OITB]";
    this.ItmsGrpNam = await this._api.GetNotFileQuery(query);
    this.ItmsGrpNam = this.ItmsGrpNam.objeto;
    this.ItmsGrpNam.unshift(
      {
        "ItmsGrpNam": "SUS PROPIAS OPORTUNIDADES",
        "ItmsGrpCod": 0,
        "checked": false
      }
    );

    this.ItmsGrpNam.forEach(element => {
      element.checked = false;

      if (this.data.CATEGORIAS && this.data.CATEGORIAS.length > 0) {
        this.data.CATEGORIAS.forEach(item => {
          if (item.ItmsGrpCod == element.ItmsGrpCod) {
            element.checked = true;
          }
        });
      }
    });

    

  }

  checkCategoria(item:any){
    item.checked = !item.checked;
    
    this.data.CATEGORIAS = [];

    this.ItmsGrpNam.forEach(element => {
      if (element.checked) {
        let x = {
          "ItmsGrpNam":element.ItmsGrpNam,
          "ItmsGrpCod":element.ItmsGrpCod
        }
        this.data.CATEGORIAS.push(x);
      }
    });

  }

  modalReference: NgbModalRef;

  async recuperarPass(){

    

    var datos:any = await this._api.EditPass(this.data);


    
    if (datos.estado) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: datos.mensaje,
        showConfirmButton: false,
        timer: 1500
      });
    }

    else
    {
      Swal.fire(datos.mensaje, '', 'error');
    }

  }

  cargando:boolean = false;

  async guardar() {


    //this.activeModal.close();
    //this.modalReference.close(this.usuario);

    this.cargando = true;

    var datos:any = await this._api.AddEditLogin(this.data);

    

    if (datos.estado) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: datos.mensaje,
        showConfirmButton: false,
        timer: 1500
      });
      this.activeModal.close(this.data);
    }
    else
    {
      Swal.fire(datos.mensaje, '', 'error');
    }

    this.cargando = false;

  }

  fileChangeEvent(fileInput: any) {
      this.imageError = null;
      if (fileInput.target.files && fileInput.target.files[0]) {
          // Size Filter Bytes
          const max_size = 20971520;
          const allowed_types = ['image/png', 'image/jpeg'];
          const max_height = 15200;
          const max_width = 25600;

          if (fileInput.target.files[0].size > max_size) {
              this.imageError =
                  'Tamaño maximo permitido ' + max_size / 1000 + 'Mb';

              return false;
          }

          if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
              this.imageError = 'Solo estos formatos son soportados ( JPG | PNG )';
              return false;
          }
          const reader = new FileReader();
          reader.onload = (e: any) => {
              const image = new Image();
              image.src = e.target.result;
              image.onload = rs => {
                  const img_height = rs.currentTarget['height'];
                  const img_width = rs.currentTarget['width'];

                  


                  if (img_height > max_height && img_width > max_width) {
                      this.imageError =
                          'Dimension maxima permitida es ' +
                          max_height +
                          '*' +
                          max_width +
                          'px';
                      return false;
                  } else {
                      const imgBase64Path = e.target.result;
                      //this.cardImageBase64 = imgBase64Path;
                      this.data.IMAGE_LITTLE = imgBase64Path;
                      this.isImageSaved = true;
                      // this.previewImagePath = imgBase64Path;
                  }
              };
          };

          reader.readAsDataURL(fileInput.target.files[0]);
      }
  }

  removeImage() {
      //this.cardImageBase64 = null;
      this.data.IMAGE_LITTLE = variableGlobal.RUTA_IMAGEN_USER_NOT_FOUND;
      this.isImageSaved = false;
  }

  cambioADMIN(){

    if( this.data.ADMIN==false){
      this.data.ADMIN=true
    }else{
      this.data.ADMIN=false
    }

  }

  cambioOITM_SAP(){

    if( this.data.OITM_SAP==false){
      this.data.OITM_SAP=true
    }else{
      this.data.OITM_SAP=false
    }

  }

  ajustaCategorias(){

    this.data.CARGO = "";

    this.ItmsGrpNam.forEach(element => {

      if (element.checked && this.data.CARGO == "") {
        this.data.CARGO = element.ItmsGrpNam;
      }
      else if(element.checked && this.data.CARGO != ""){
        this.data.CARGO = this.data.CARGO + ' | ' + element.ItmsGrpNam;
      }

    });
  }

  @ViewChild('taskAddInput') taskAddInput!: ElementRef;

  tasks: any[] = [
    { id: 1, name: 'Task number one', checked: false },
    { id: 2, name: 'Second Task', checked: false },
    { id: 3, name: 'Third task', checked: false },
    { id: 4, name: 'Task number four', checked: false }
  ];
  newTask: string = '';

  onFocus() {
    this.taskAddInput.nativeElement.value = '';
  }

  onBlur() {
    if (this.taskAddInput.nativeElement.value === '') {
      this.taskAddInput.nativeElement.value = '+ add new task';
    }
  }

  addTask() {
    if (this.newTask.trim() !== '') {
      const newId = this.tasks.length + 1;
      this.tasks.push({ id: newId, name: this.newTask, checked: false });
      this.newTask = '';
    }
  }

  removeTask(index: number) {
    this.tasks.splice(index, 1);
  }

  checkList() {
    // Aquí iría la lógica de la función checkList() original
  }

  toggleBodegaPermitida(whsCode: string) {
    if (!Array.isArray(this.data.BODEGAS_PERMITIDAS)) this.data.BODEGAS_PERMITIDAS = [];
    const idx = this.data.BODEGAS_PERMITIDAS.indexOf(whsCode);
    if (idx >= 0) {
      this.data.BODEGAS_PERMITIDAS.splice(idx, 1);
    } else {
      this.data.BODEGAS_PERMITIDAS.push(whsCode);
    }
  }

  isBodegaPermitida(whsCode: string): boolean {
    return Array.isArray(this.data.BODEGAS_PERMITIDAS) && this.data.BODEGAS_PERMITIDAS.includes(whsCode);
  }

}
